import '../static/Card.css';
import React__default from "react";
import clsx from "clsx";
import Link from "next/link.js";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
import { a as addRelAndTarget } from "./addRelAndTarget.DDvAIEJJ.mjs";
const card = `_card_c021704`;
const hasBackground = `_hasBackground_6f9d78d`;
const hasPadding = `_hasPadding_aa94f0a`;
const hasHoverEffect = `_hasHoverEffect_11a6f66`;
const styles = { card, hasBackground, hasPadding, hasHoverEffect };
const Card = ({
  as,
  className,
  children,
  hasBackground: hasBackground2 = true,
  hasHoverEffect: hasHoverEffect2,
  hasPadding: hasPadding2 = true,
  ...props
}) => {
  const Component = useTagName(props.href && !as ? Link : as);
  const linkProps = props.href ? addRelAndTarget(props.target) : {};
  return /* @__PURE__ */ React__default.createElement(
    Component,
    {
      "data-ui-card": true,
      className: clsx(
        styles.card,
        {
          [styles.hasBackground]: hasBackground2,
          [styles.hasHoverEffect]: hasHoverEffect2,
          [styles.hasPadding]: hasPadding2
        },
        className
      ),
      ...linkProps,
      ...props
    },
    children
  );
};
export {
  Card as C
};
//# sourceMappingURL=Card.BpXboJlO.mjs.map
